import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "../ModalLayout/ModalLayout";
import checkmark from "../../../../public/images/checkmark-green.png";
import errorIcon from "../../../../public/images/error-x.svg";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import { ApplyTemplateToProps } from "app/components/Button/ApplyTemplateDropdown/index.types";
import { useTranslation } from 'react-i18next';
import ButtonVariant from "app/components/Button/ButtonVariant";

const ApplyTemplateSuccessModal = ({
  isSuccessModalOpen,
  onSuccessModalClose,
  templateName,
  appliedLocation,
  applied,
}: ApplyTemplateToProps) => {
  const { t } = useTranslation();
  const applyTemplateError = useSelector(
    (state: RootState) => state.applyTemplate.errorApplyTemplate, shallowEqual
  );

  return (
    <ModalLayout isOpen={isSuccessModalOpen} onClose={onSuccessModalClose}>
      <div className={styles.container}>
        <img
          src={applyTemplateError ? errorIcon : checkmark}
          alt="success"
          className={styles.checkMark}
        />
        <h1 className={styles.title}>
          {applyTemplateError ? t("Something went wrong") : t("Template applied")}
        </h1>
        <p className={styles.info}>
          {templateName ? `"${templateName}"` :
          (applyTemplateError ? t("Template wasn't applied to ") : t("Template was successfully applied to "))}
          <b>{applied}</b> {appliedLocation}
          {applyTemplateError && ", " + t("please try again")}
        </p>
        <ButtonVariant
          title={t("Ok")}
          buttonType="primary"
          onClickFunc={onSuccessModalClose}
          buttonStyles={styles.done_button}
        />
      </div>
    </ModalLayout>
  );
};

export default ApplyTemplateSuccessModal;
